
import Phaser from 'phaser';
import { PerformanceConfig } from './PerformanceSettings';
import { NPCBehaviorController } from '../engine/NPCBehaviorController';
import { NPCSprite } from '../engine/NPCSprite';

export class NPCCullingManager {
  private readonly states = new WeakMap<NPCBehaviorController, number>();
  constructor(
    private readonly scene: Phaser.Scene,
    private readonly config: PerformanceConfig['npc'],
  ) {}

  update(time: number, controllers: NPCBehaviorController[]) {
	const worldView = this.scene.cameras.main.worldView;
	const view = new Phaser.Geom.Rectangle(
	  worldView.x,
	  worldView.y,
	  worldView.width,
	  worldView.height
	);
    view.x -= this.config.cameraCullPadding;
    view.y -= this.config.cameraCullPadding;
    view.width += this.config.cameraCullPadding * 2;
    view.height += this.config.cameraCullPadding * 2;

    controllers.forEach((controller) => {
      const sprite = controller.getSprite();
      if (!sprite.active || !sprite.scene) return;
      const inView = view.contains(sprite.x, sprite.y);
      if (this.config.hideOffscreenSprites) sprite.setVisible(inView);
      const interval = inView ? this.config.onscreenUpdateIntervalMs : this.config.offscreenUpdateIntervalMs;
      const nextAt = this.states.get(controller) ?? 0;
      if (time < nextAt) return;
      if (!inView) {
        const body = sprite.body as Phaser.Physics.Arcade.Body | undefined;
        body?.setVelocity(0, 0);
        sprite.playIdle();
      }
      controller.update(time);
      this.states.set(controller, interval > 0 ? time + interval : time);
    });
  }
}
